import React from "react";

import { getAutomationDataAttr } from "../../../../utils/automationUtils";

import "./styles.scss";
import { Image, Text, TextColors, TextTypes } from "../../../../component-library";

export default ({ onClick }) => (
  <div className="AddendumLink" onClick={onClick} {...getAutomationDataAttr("note-addendum-link")}>
    <div className="AddendumLink--left">
      <Text type={TextTypes.heading2} layout="block">
        Add Addendum
      </Text>
      <Text type={TextTypes.paragraph} color={TextColors.grey} layout="block">
        Add details to an existing note.
      </Text>
    </div>
    <Image className="AddendumLink__icon" src="icons/common/chevron-right-blue.svg" alt="arrow" />
  </div>
);
